<template>
  <!-- modal -->
  <div class="dimed wrap">
    <div class="layer">
      <div class="layer__header">
        <div class="lyr-title">{{ $t('Modal.CashRecipt.msg1') }}</div>
        <div class="ft-point">{{ $t('Modal.CashRecipt.msg2') }}</div>
        <div class="lyr-txt">{{ $t('Modal.CashRecipt.msg3') }}</div>
      </div>
      <div class="layer__body mg-sm">
        <div class="flex-row">
          <div class="input-area">
            <label for="">{{ $t('Modal.CashRecipt.msg4') }}</label>
            <input type="text" v-if="!eyeActive" maxlength="11" :placeholder="$t('Modal.CashRecipt.msg5')" :value="reciptData" />
            <input type="text" v-if="eyeActive" maxlength="11" :placeholder="$t('Modal.CashRecipt.msg5')" :value="orgReciptData" />
            <button class="btn-eye" :class="{masking: !eyeActive}" @mouseup="eyeActive = eyeActive ? false : true"></button>
            <!-- <button class="btn-eye masking"></button> -->
          </div>
          <div class="lyr-left">
            <div>
              <input type="radio" name="radio" id="radio01" class="radio-t02" checked />
              <label for="radio01">{{ $t('Modal.CashRecipt.msg6') }}</label>
            </div>
            <div>
              <input type="radio" name="radio" id="radio02" class="radio-t02" />
              <label for="radio02">{{ $t('Modal.CashRecipt.msg7') }}</label>
            </div>
          </div>
          <div class="lyr-right">
            <div class="keypad">
              <button @mouseup="setRecipt(1)">1</button>
              <button @mouseup="setRecipt(2)">2</button>
              <button @mouseup="setRecipt(3)">3</button>
              <button @mouseup="setRecipt(4)">4</button>
              <button @mouseup="setRecipt(5)">5</button>
              <button @mouseup="setRecipt(6)">6</button>
              <button @mouseup="setRecipt(7)">7</button>
              <button @mouseup="setRecipt(8)">8</button>
              <button @mouseup="setRecipt(9)">9</button>
              <button @mouseup="setRecipt(10)" class="delete">{{ $t('Modal.CashRecipt.msg8') }}</button>
              <button @mouseup="setRecipt(0)">0</button>
              <button @mouseup="setRecipt(-1)" class="btn-back">DEL</button>
            </div>
          </div>
          <div class="txt-tip center">{{ $t('Modal.CashRecipt.msg9') }}</div>
        </div>
      </div>
      <div class="layer__button">
        <button class="btn btn--cancel" @mouseup="$emit('closeCashRecipt')">{{ $t('Modal.CashRecipt.msg11') }}</button>
        <button class="btn btn--submit" :class="[orgReciptData.length < 11 ? 'btn--disabled' : 'btn--color']">
          {{ $t('Modal.CashRecipt.msg10') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'cashRecipt',
  data() {
    return {
      reciptData: '',
      orgReciptData: '',
      darkModeYn: this.$store.getters.getDarkModeYn,
      eyeActive: false,
    };
  },
  mounted() {},
  props: {},
  methods: {
    setRecipt(num) {
      if (num == 10) this.orgReciptData = '';
      else if (num < 0) this.orgReciptData = this.orgReciptData.slice(0, -1);
      else if (this.orgReciptData.length < 11) this.orgReciptData += num + '';

      var str = this.orgReciptData.split('');
      for (let i = 0; i < str.length; i++) {
        if (i >= 3 && i <= 6) {
          str[i] = '*';
        }
      }

      this.reciptData = str.join('');
      // if (this.orgReciptData.length > 7) this.reciptData = this.orgReciptData.slice(0, 7) + '*'.repeat(this.orgReciptData.length - 7);
      // else this.reciptData = this.orgReciptData;
    },
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/keypad.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/keypad-dark.css" scoped></style>
<style scoped></style>
